var script = document.createElement("script");
script.src = "//widget.simplybook.it/v2/widget/widget.js";
script.onload = function () {
    new SimplybookWidget({
        "widget_type":"button",
        "url":"https://leekscustoms.simplybook.it",
        "theme":"air",
        "theme_settings":{
            "timeline_modern_display":"as_slots",
            "timeline_hide_unavailable":"1",
            "hide_past_days":"0",
            "timeline_show_end_time":"0",
            "sb_base_color":"#7b8a78",
            "display_item_mode":"block",
            "booking_nav_bg_color":"#7b8a78",
            "body_bg_color":"#ffffff",
            "sb_review_image":"",
            "dark_font_color":"#474747",
            "light_font_color":"#ffffff",
            "btn_color_1":"#b0c3ac",
            "sb_company_label_color":"#ffffff",
            "hide_img_mode":"0",
            "show_sidebar":"1",
            "sb_busy":"#c7b3b3",
            "sb_available":"#d6ebff"
        },
        "timeline":"modern",
        "datepicker":"top_calendar",
        "is_rtl":false,
        "app_config":{
            "clear_session":0,
            "allow_switch_to_ada":0,
            "predefined":[]
        },
        "button_title":"Prenota ora",
        "button_background_color":"#7b8a78",
        "button_text_color":"#ffffff",
        "button_position":"right",
        "button_position_offset":"55%"
    });
};

document.head.appendChild(script);
